// The mobile drawer. Focus is trapped while it's open and returned
// to the button that opened it.

export default function menu() {
    const openButton = document.querySelector('[data-menu-open]');
    const drawer = document.getElementById('site-drawer');
    if (!openButton || !drawer) return;

    const scrim = document.querySelector('.drawer-scrim');
    const closers = Array.from(document.querySelectorAll('[data-menu-close]'));

    function setOpen(open) {
        document.body.classList.toggle('is-menu-open', open);
        openButton.setAttribute('aria-expanded', String(open));
        if (scrim) scrim.hidden = !open;

        if (open) {
            const first = drawer.querySelector('a, button');
            if (first) first.focus();
        } else {
            openButton.focus();
        }
    }

    openButton.addEventListener('click', () => setOpen(true));
    closers.forEach((el) => el.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && document.body.classList.contains('is-menu-open')) {
            setOpen(false);
        }
    });

    // Close after following a link inside the drawer
    drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
    });
}
